import { useSelector, shallowEqual } from 'react-redux';
import { AppState } from '../app-state';
import { CodatState, SnackBar } from './ui-state';

// export const useProgress = (): boolean => {
//   const loading = useSelector(
//     (state: AppState) => state.ui.progress,
//     shallowEqual
//   );

//   return loading || false;
// };

export const useCodatState = (): CodatState | null => {
  const codatState = useSelector(
    (state: AppState) => state.ui.codatState,
    shallowEqual
  );
  return codatState;
}

export const useSnackBar = (): SnackBar | null => {
  const snackBar = useSelector(
    (state: AppState) => state.ui.snackBar,
    shallowEqual
  );

  return snackBar;
};
export const useCurrentStepperIndex = (): number => {
  const stepIndex = useSelector(
    (state: AppState) => state.ui.currentStepperIndex,
    shallowEqual
  );

  return stepIndex;
};
export const useCheckIntegration = (): boolean => {
  const checkIntegration = useSelector(
    (state: AppState) => state.ui.checkIntegration,
    shallowEqual
  );
  return checkIntegration;
};
export const useDocumentUploadBack = (): boolean => {
  const documentUploadBack = useSelector(
    (state: AppState) => state.ui.documentUploadBack,
    shallowEqual
  );
  return documentUploadBack;
};
export const useDisableButton = (): boolean => {
  const disableButton = useSelector(
    (state: AppState) => state.ui.disableButton,
    shallowEqual
  );
  return disableButton;
};
